import React, { Component } from "react";
// import CryptoJS from "crypto-js";
import { Container } from "@material-ui/core";
import "./login.css";
// import { fetchMethod, loginfetchMethod } from "../FetchMethod";

// import { mutationQueries, mutationQueriesNew } from "../MutationMethod";
// import { login, getLoggedInUser } from "./LoginQueries";

import Sidebar from "../SideBar/Sidebar";
import { loginComponents } from "./LoginRouteContent";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
class PreLoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      showPassword: false,
      isChecked: false,
    };
  }

  render() {
    const storageToken = localStorage.getItem("token");
    if (storageToken && localStorage.getItem("name")) {
      return <Route component={Sidebar} path="/" />;
    }
    return (
      <Router>
        <div className="login loginFormOuterContainer">
          <div className="loginFromContainer">
            <Container className="loginContainerBlue">
              <div>
                <form noValidate onSubmit={this.onSubmit}>
                  <div className="logoPart">
                    <h2>
                      <span>Uptake</span>Medical <sup>R</sup>
                    </h2>
                    <span>A Broncus Company</span>
                  </div>
                </form>
              </div>
            </Container>
            <Container className="loginContainerwhite">
              <Switch>
                {loginComponents.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={route.main}
                  />
                ))}
                <Redirect to="/" />
              </Switch>
            </Container>
          </div>
        </div>
      </Router>
    );
  }
}

export default PreLoginComponent;
